/* Duinadem — dn-product.js
   Kleurkeuze met bolletjes, pijltjes bij de foto's en de prijs in de koopknop.
   Werkt samen met np-product.js (die doet bundels en winkelwagen). */
(function () {
  'use strict';

  function init(root) {
    if (root.__dnPm) return;
    root.__dnPm = true;

    var map = [];
    var raw = root.querySelector('[data-dn-variant-map]');
    if (raw) { try { map = JSON.parse(raw.textContent) || []; } catch (e) { map = []; } }

    var base = root.querySelector('[data-np-base-variant]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-dn-option]'));

    function fire(el) { el.dispatchEvent(new Event('change', { bubbles: true })); }

    function goToMedia(pos) {
      if (!pos) return;
      var t = root.querySelector('[data-np-gallery-goto="' + (pos - 1) + '"]');
      if (t) t.click();
    }

    function currentOpts() {
      var chosen = {};
      groups.forEach(function (g) {
        var a = g.querySelector('.dn-pm__sw.is-active');
        if (a) chosen[g.dataset.dnOption] = a.dataset.dnValue;
      });
      return chosen;
    }

    function findVariant(chosen) {
      for (var i = 0; i < map.length; i++) {
        var ok = true;
        for (var k in chosen) {
          if (map[i].opts[k] !== chosen[k]) { ok = false; break; }
        }
        if (ok) return map[i];
      }
      return null;
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.dn-pm__sw');
        if (!b) return;
        g.querySelectorAll('.dn-pm__sw').forEach(function (x) {
          x.classList.toggle('is-active', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        var cur = g.querySelector('[data-dn-option-current]');
        if (cur) cur.textContent = b.dataset.dnLabel || b.dataset.dnValue;

        var v = findVariant(currentOpts());
        if (!v) return;
        if (base) { base.value = String(v.id); fire(base); }
        root.querySelectorAll('[data-np-unit-variant]').forEach(function (s) {
          s.value = String(v.id); fire(s);
        });
        goToMedia(v.media);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (err) {}
        updateButton();
      });
    });

    /* Foto-pijltjes */
    var vp = root.querySelector('[data-np-gallery-viewport]');
    root.querySelectorAll('[data-dn-gal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!vp) return;
        var n = vp.children.length;
        var i = Math.round(vp.scrollLeft / Math.max(vp.clientWidth, 1));
        var next = (i + parseInt(btn.dataset.dnGal, 10) + n) % n;
        var t = root.querySelector('[data-np-gallery-goto="' + next + '"]');
        if (t) t.click(); else vp.scrollTo({ left: vp.clientWidth * next, behavior: 'smooth' });
      });
    });

    /* Prijs zonder bundelkorting doorgestreept in de knop */
    var cmp = root.querySelector('[data-dn-btn-compare]');
    function updateButton() {
      if (!cmp) return;
      var tier = root.querySelector('[data-np-tier]:checked');
      var box = tier ? tier.closest('.np-tier') : null;
      var c = box ? box.querySelector('[data-np-tier-compare]') : null;
      var pct = tier ? parseFloat(tier.dataset.discount) || 0 : 0;
      if (c && pct > 0 && c.textContent.trim()) {
        cmp.textContent = c.textContent;
        cmp.hidden = false;
      } else {
        cmp.hidden = true;
      }
    }
    root.addEventListener('change', function () { window.requestAnimationFrame(updateButton); });
    window.setTimeout(updateButton, 60);
    window.addEventListener('load', updateButton);
  }

  function boot() { document.querySelectorAll('[data-dn-pm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
